/**
 * /api/bwra/state — key-value-state per tenant för BWRA-modulen.
 *
 * BWRAService dual-writar alla skriv-metoder hit. Vid login pullar
 * initFromBackend() alla keys och merger in localStorage.
 */

import { http } from './httpClient';

export async function getAllState(opts = {}) {
  const result = await http.get('/bwra/state', opts);
  return result.data || {};
}

export async function getState(key, opts = {}) {
  const result = await http.get(`/bwra/state/${encodeURIComponent(key)}`, opts);
  return result.data;  // null om saknas
}

/**
 * Bulk-upsert flera keys i en request. Mest effektivt vid initFromBackend
 * eller stor save-batch.
 */
export async function patchState(patch, opts = {}) {
  const result = await http.patch('/bwra/state', patch, opts);
  return result.data || {};
}

/**
 * Set EN key. Används av dual-write-helpers i BWRAService för varje
 * save-metod (saveRisks, saveScope, saveAppetite osv.).
 */
export async function putState(key, value, opts = {}) {
  const result = await http.put(`/bwra/state/${encodeURIComponent(key)}`, value, opts);
  return result.data;
}

export async function removeState(key, opts = {}) {
  await http.delete(`/bwra/state/${encodeURIComponent(key)}`, opts);
}
